var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[(_vm.type == 1)?_c('list',{on:{"handleClick":_vm.handleClick,"bindShowDispose":_vm.showDispose}}):_vm._e(),(_vm.type == 2)?_c('three-d',{attrs:{"rowId":_vm.rowId,"pageTitle":_vm.pageTitle,"tableData":_vm.tableData},on:{"close":_vm.editClose,"back":_vm.back}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }